@for (contract of contracts; track contract.id) {
    <button
        contractListItem
        class="contract-list-item"
        [contract]="contract"
        (click)="handleClick(contract.id)"
    ></button>
}
